<template>
<div class="right-pane">
  <el-collapse v-model="activeCollapse" accordion>
    <el-collapse-item title="属性" name="属性">
      <template v-if="node_obj.shape==='er-rect'">
        <el-tabs type="border-card" v-if="node_obj.id">
          <el-tab-pane label="数据">
            <el-descriptions class="margin-top" :column="2" size="mini" border>
              <el-descriptions-item label="名称">
                <el-input :disabled="true" v-model="node_obj.attrs.text.text" @change="initChange" ></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="主表">
                <el-checkbox :value="node_obj.data.checked" @change="inputData(node_obj.data,'checked',$event)"></el-checkbox>
              </el-descriptions-item>
            </el-descriptions>
            <div>
              <el-table
                :data="node_obj.ports.items"
                style="width: 100%" height="400px">
                <el-table-column
                  label="ID"
                  width="50">
                  <template slot-scope="scope">
                    <el-checkbox :value="scope.row.checked" @change="inputData(scope.row,'checked',$event)"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="attrs.portNameLabel.text"
                  label="字段"
                  width="120">
                  <template slot-scope="scope">
                    {{scope.row.attrs.portNameLabel.text}} {{scope.row.attrs.portPrimaryLabel.text?("("+scope.row.attrs.portPrimaryLabel.text+")"):""}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="attrs.portTypeLabel.text"
                  label="类型"
                  width="90">
                </el-table-column>
                <el-table-column
                  prop="attrs.portCommentLabel.text"
                  label="名称"
                  width="100">
                </el-table-column>
              </el-table>
            </div>

          </el-tab-pane>
          <el-tab-pane label="属性">
            <el-descriptions class="margin-top" :column="1" size="mini" border>
              <el-descriptions-item label="id">
                <el-input :disabled="true" v-model="node_obj.id" ></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="类型">
                <el-input :disabled="true" v-model="node_obj.shape" ></el-input>
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template v-if="node_obj.shape==='edge'">
        <el-tabs type="border-card" v-if="node_obj.id">
          <el-tab-pane label="数据">
            <el-descriptions class="margin-top" :column="1" size="mini" border>
              <el-descriptions-item label="左数据">
                <el-input :disabled="true" v-model="node_obj.source.cell" @change="initChange" ></el-input>
                <el-input :disabled="true" v-model="node_obj.source.port" @change="initChange" ></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="右数据">
                <el-input :disabled="true" v-model="node_obj.target.cell" @change="initChange" ></el-input>
                <el-input :disabled="true" v-model="node_obj.target.port" @change="initChange" ></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="数据关系">
                <el-radio v-for="(item,index) in join_list" @input="inputData(node_obj.data,'join_ext',$event)" :key="index" :value="node_obj.data.join_ext" :label="item.value">{{ item.name }}</el-radio>
              </el-descriptions-item>
            </el-descriptions>

          </el-tab-pane>
          <el-tab-pane label="属性">
            <el-descriptions class="margin-top" :column="1" size="mini" border>
              <el-descriptions-item label="id">
                <el-input :disabled="true" v-model="node_obj.id" ></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="类型">
                <el-input :disabled="true" v-model="node_obj.shape" ></el-input>
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
        </el-tabs>
      </template>

    </el-collapse-item>
  </el-collapse>

</div>
</template>

<script>
import { Node,Edge } from '@antv/x6'

export default {
  name: "LFComponents",
  props:{
    nodeObj:{
      type:Node|Edge,
      default(){
        return{}
      }
    }
  },
  model:{
    prop:"nodeObj",
    event:"success",
  },
  data(){
    return{
      node_obj:{},
      join_list:[
        {name:'左联',value:'left join'},
        {name:'右联',value:'right join'},
        {name:'内联',value:'inner join'},
        {name:'外联',value:'out join'},
      ],
      activeCollapse:false,
    }
  },
  mounted() {
    this.initData()
  },
  watch:{
    nodeObj(){
      this.initData()
    }
  },
  methods:{
    initData(){
      var that=this;
      that.node_obj={};
      that.$nextTick(function () {
        that.node_obj=that.nodeObj;
        that.node_obj.data=that.node_obj.data||{}
      });
    },
    inputData(node,name,value){
      node[name]=value;
      this.$forceUpdate();
      this.$emit('success',this.node_obj)
    },
    initChange(){
      // this.$emit('success',this.node_obj)
    },
  }
}
</script>

<style lang="scss" scoped>
.right-pane{
  position: absolute;
  right: 5px;
  top: 5px;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Database/components/LFComponents.vue